<div class="wrapper wrapper-content animated fadeInRight">
  
  <div id="grid-wrapper">
    <!-- Header Alarms -->
    <div class="grid-box-lg highlighted-container">
      <div class="grid-box-highlighted grid-box-hover danger" [routerLink]="['/alarms']">
        <div class="highlighted-icon">
          <i class="fa fa-bell"></i>
        </div>
        <div class="highlighted-body">
          <p>{{ alarmDashboardService.alarms.length }} Active Alarms</p>
          <i class="fa fa-arrow-right"></i>
        </div>
      </div>

      <div class="grid-box-highlighted" [ngClass]="{'danger':alarmDashboardService.dashboard.globalAlarms.data.contaminatedWaterAlarm, 'default':!alarmDashboardService.dashboard.globalAlarms.data.contaminatedWaterAlarm }">
        <div class="highlighted-icon">
          <i class="fa fa-flask"></i>
        </div>
        <div class="highlighted-body">
          <p>Contaminated Water</p>
        </div>
      </div>

      <div class="grid-box-highlighted" [ngClass]="{'danger':alarmDashboardService.dashboard.globalAlarms.data.highWindAlarm, 'default':!alarmDashboardService.dashboard.globalAlarms.data.highWindAlarm }">
        <div class="highlighted-icon">
          <i class="fa fa-flag"></i>
        </div>
        <div class="highlighted-body">
          <p>High Wind</p>
        </div>
      </div>

      <div class="grid-box-highlighted" [ngClass]="{'danger':alarmDashboardService.dashboard.globalAlarms.data.highRainAlarm, 'default':!alarmDashboardService.dashboard.globalAlarms.data.highRainAlarm }">
        <div class="highlighted-icon">
          <i class="fa fa-cloud"></i>
        </div>
        <div class="highlighted-body">
          <p>High Rain</p>
        </div>
      </div>

      <div class="grid-box-highlighted" [ngClass]="{'info':alarmDashboardService.dashboard.globalAlarms.data.awrfActive, 'default':!alarmDashboardService.dashboard.globalAlarms.data.awrfActive }">
        <div class="highlighted-icon">
          <i class="fa fa-tint"></i>
        </div>
        <div class="highlighted-body">
          <p>AWRF Active</p>
        </div>
      </div>

    </div>

    <!-- Tanks, Weather, Schedule Usage -->
    <div class="card grid-box grid-box-sm bg-emphasis bg-opacity-25">
      <div class="card-header grid-box-header">
        <h1 class="grid-box-title">Water Levels</h1>
      </div>
      <div class="card-body grid-box-body grid-box-number">
        <ng-template [ngIf]="alarmDashboardService.dashboard.reservoirUsage.loaded" [ngIfElse]="reservoirLoading">
          <highcharts-chart
                [Highcharts]="Highcharts"
                [options]="tankOptions"
                [callbackFunction]="tankCallback"
                [(update)]="tankUpdateFlag"
                style="display: block; width: 100%;">
          </highcharts-chart>
        </ng-template>
        <ng-template #reservoirLoading>
          <div class="loader-spinner"></div>
        </ng-template>

      </div>
      <div class="card-arrow">
        <div class="card-arrow-top-left"></div>
        <div class="card-arrow-top-right"></div>
        <div class="card-arrow-bottom-left"></div>
        <div class="card-arrow-bottom-right"></div>
      </div>
    </div>

    <!-- Weather -->
    <div class="card grid-box grid-box-sm bg-emphasis bg-opacity-10" *ngFor="let weatherStation of alarmDashboardService.dashboard.weatherStations.data">
      <div class="card-header grid-box-header">
        <h1 class="grid-box-title">{{weatherStation.name}}</h1>
      </div>
      <div class="card-body grid-box-body grid-box-number">
        <app-windrose-home [weatherStation]="weatherStation"></app-windrose-home>
      </div>
      <div class="card-arrow">
        <div class="card-arrow-top-left"></div>
        <div class="card-arrow-top-right"></div>
        <div class="card-arrow-bottom-left"></div>
        <div class="card-arrow-bottom-right"></div>
      </div>
    </div>

    <!-- Schedule -->
    <div class="grid-box-sm grid-box-parent">
      <div class="card grid-box bg-emphasis bg-opacity-15">
        <div class="card-header grid-box-header">
          <h1 class="grid-box-title">Current Schedule</h1>
          <a class="grid-box-link" [routerLink]="['/schedule/current']">View<i class="fa fa-arrow-right"></i></a>
        </div>
        <div class="card-body grid-box-body grid-box-number">
          <ng-template [ngIf]="alarmDashboardService.dashboard.scheduleRequirements.loaded" [ngIfElse]="scheduleCurrentUsageLoaded">

            <div class="grid-box-schedule-value-wrap">
              <h2>Total Requirement</h2>
              <p class="grid-box-schedule-value">
                <span title="Current usage for this period">{{ alarmDashboardService.dashboard.scheduleRequirements.data.thisWeeksTotalUsage | number: '1.0-0' }} <small>kL</small></span> 
                / 
                <span title="Allocated usage for this period">{{ alarmDashboardService.dashboard.scheduleRequirements.data.thisWeeksRequirements | number: '1.0-0' }} <small>kL</small></span>
              </p>
            </div>
            <div class="grid-box-schedule-value-wrap">
              <h2>Total Flow</h2>
              <p class="grid-box-schedule-value">
                <span title="Current flow rate">{{ alarmDashboardService.dashboard.meterDetails.data | flowTotal: true | number: '1.0-0' }} <small>kL</small></span> 
                / 
                <span title="Expected flow rate">{{ alarmDashboardService.dashboard.meterDetails.data | flowTotal | number: '1.0-0' }} <small>kL</small></span>
              </p>
            </div>

          </ng-template>
          <ng-template #scheduleCurrentUsageLoaded>
            <div class="loader-spinner"></div>
          </ng-template>
        </div>
        <div class="card-arrow">
          <div class="card-arrow-top-left"></div>
          <div class="card-arrow-top-right"></div>
          <div class="card-arrow-bottom-left"></div>
          <div class="card-arrow-bottom-right"></div>
        </div>
      </div>

      <div class="card grid-box bg-emphasis bg-opacity-15">
        <div class="card-header grid-box-header">
          <h1 class="grid-box-title">Upcoming Schedule</h1>
          <a class="grid-box-link" [routerLink]="['/schedule/upcoming']">View<i class="fa fa-arrow-right"></i></a>
        </div>
        <div class="card-body grid-box-body grid-box-number">
          <ng-template [ngIf]="alarmDashboardService.dashboard.scheduleRequirements.loaded" [ngIfElse]="scheduleUpcomingUsageLoading">
            
            <div class="grid-box-schedule-value-wrap">
              <h2>Total Requirement</h2>
              <p class="grid-box-schedule-value">{{ alarmDashboardService.dashboard.scheduleRequirements.data.nextWeeksRequirements | number: '1.0-0' }} <small>kL</small></p>
            </div>
          
          </ng-template>
          <ng-template #scheduleUpcomingUsageLoading>
            <div class="loader-spinner"></div>
          </ng-template>
        </div>
        <div class="card-arrow">
          <div class="card-arrow-top-left"></div>
          <div class="card-arrow-top-right"></div>
          <div class="card-arrow-bottom-left"></div>
          <div class="card-arrow-bottom-right"></div>
        </div>
      </div>

      <!-- EVAP -->
      <div class="card grid-box bg-emphasis bg-opacity-15">
        <div class="card-header grid-box-header">
          <h1 class="grid-box-title">Evapotranspiration</h1>
        </div>
        <div class="card-body grid-box-body grid-box-number">
          <ng-template [ngIf]="alarmDashboardService.dashboard.weatherStations.loaded" [ngIfElse]="evapLoading">
            <table>
              <tr>
                <th></th>
                <th>Yesterday</th>
                <th>This Week</th>
              </tr>
              <tr>
                <th>ETo</th>
                <td [title]="alarmDashboardService.dashboard.evapotranspiration.deviceInEto.timeStamp">{{ alarmDashboardService.dashboard.evapotranspiration.deviceInEto.value ? (alarmDashboardService.dashboard.evapotranspiration.deviceInEto.value | number: '1.2-2') : '0' }} mm</td>
                <td [title]="alarmDashboardService.dashboard.evapotranspiration.deviceInEtWko.timeStamp">{{ alarmDashboardService.dashboard.evapotranspiration.deviceInEtWko.value ? (alarmDashboardService.dashboard.evapotranspiration.deviceInEtWko.value | number: '1.2-2') : '0' }} mm</td>
              </tr>             
            <tr>
              <th>PTo</th>
              <td [title]="alarmDashboardService.dashboard.evapotranspiration.deviceInPto.timeStamp">{{ alarmDashboardService.dashboard.evapotranspiration.deviceInPto.value ? (alarmDashboardService.dashboard.evapotranspiration.deviceInPto.value | number: '1.2-2') : '0' }} mm</td>
              <td [title]="alarmDashboardService.dashboard.evapotranspiration.deviceInPtWko.timeStamp">{{ alarmDashboardService.dashboard.evapotranspiration.deviceInPtWko.value ? (alarmDashboardService.dashboard.evapotranspiration.deviceInPtWko.value | number: '1.2-2') : '0' }} mm</td>
            </tr>			
            <tr>
              <th>SMD</th>
              <!-- + is red, - is green -->
              <td [title]="alarmDashboardService.dashboard.evapotranspiration.deviceInSmd.timeStamp" [ngClass]="{'dry':alarmDashboardService.dashboard.evapotranspiration.deviceInSmd && alarmDashboardService.dashboard.evapotranspiration.deviceInSmd.value >= 0, 'wet':alarmDashboardService.dashboard.evapotranspiration.deviceInSmd && alarmDashboardService.dashboard.evapotranspiration.deviceInSmd.value < 0 }">
                {{ alarmDashboardService.dashboard.evapotranspiration.deviceInSmd.value ? (alarmDashboardService.dashboard.evapotranspiration.deviceInSmd.value | number: '1.2-2') : '0' }} mm
              </td>
              <td [title]="alarmDashboardService.dashboard.evapotranspiration.deviceInSmdWko.timeStamp" [ngClass]="{'dry':alarmDashboardService.dashboard.evapotranspiration.deviceInSmd && alarmDashboardService.dashboard.evapotranspiration.deviceInSmd.value >= 0, 'wet':alarmDashboardService.dashboard.evapotranspiration.deviceInSmd && alarmDashboardService.dashboard.evapotranspiration.deviceInSmd.value < 0 }">
                {{ alarmDashboardService.dashboard.evapotranspiration.deviceInSmdWko.value ? (alarmDashboardService.dashboard.evapotranspiration.deviceInSmdWko.value | number: '1.2-2') : '0' }} mm
              </td>
            </tr>
          </table>
          </ng-template>
          <ng-template #evapLoading>
            <div class="loader-spinner"></div>
          </ng-template>
        </div>
        <div class="card-arrow">
          <div class="card-arrow-top-left"></div>
          <div class="card-arrow-top-right"></div>
          <div class="card-arrow-bottom-left"></div>
          <div class="card-arrow-bottom-right"></div>
        </div>
      </div>
    </div>

    <!-- WEEKLY USAGE -->
    <div class="card grid-box grid-box-lg bg-emphasis bg-opacity-50">
      <div class="card-header grid-box-header">
        <h1 class="grid-box-title">Flow Forecast ({{expectedUsage | number: '1.0-0' }} kL remaining)</h1>
      </div>
      <div class="card-body grid-box-body grid-box-endpoint">
        <ng-template [ngIf]="flowLoaded" [ngIfElse]="flowForecastLoading">
          <highcharts-chart
                [Highcharts]="Highcharts"
                [options]="flowOptions"
                [callbackFunction]="flowCallback"
                [(update)]="flowUpdateFlag"
                style="display: block; width: 100%;">
          </highcharts-chart>
        </ng-template>
        <ng-template #flowForecastLoading>
          <div class="loader-spinner"></div>
        </ng-template>
      </div>
      <div class="card-arrow">
        <div class="card-arrow-top-left"></div>
        <div class="card-arrow-top-right"></div>
        <div class="card-arrow-bottom-left"></div>
        <div class="card-arrow-bottom-right"></div>
      </div>
    </div> 

    <!-- ENDPOINTS BY CUSTOMER -->
    <div class="card grid-box grid-box-lg bg-emphasis bg-opacity-30">
      <div class="card-header grid-box-header">
        <h1 class="grid-box-title">Endpoint Status</h1>
      </div>
      <div class="card-body grid-box-body grid-box-endpoint">
        <ng-template [ngIf]="alarmDashboardService.dashboard.meterDetails.loaded" [ngIfElse]="meterUsageLoading">
          <div class="grid-box-endpoint-customer-wrap" *ngFor="let customer of alarmDashboardService.dashboard.meterDetails.data | customerFilter: authService.currentUser">
            <div class="grid-box-endpoint-customer">
              <p class="title">{{ customer.name }}</p>

              <div class="customer-bar-container" *ngIf="customer.Id | findCustomerUsage: alarmDashboardService.dashboard.customerUsages.data; let customerUsage">

                <div class="customer-bar-wrap">
                  <!-- expected max flow and min flow? -->
                  <div class="customer-bar-alert basic-tooltip-alert" *ngIf="customerUsage.currentFlow > customerUsage.expectedFlow">
                    <i class="fa fa-exclamation"></i>
                    <div class="endpoint-basic-tooltip">
                      <p>Customer's current flow is greater than expected flow {{customerUsage.currentFlow}} > {{customerUsage.expectedFlow}}</p>
                    </div>
                  </div>
                  
                  <div class="customer-bar">
                    <div class="customer-bar-inner" [ngStyle]="{ 'width.%': ([customer] | flowTotal) > customerUsage.currentFlow ? customerUsage.currentFlow / ([customer] | flowTotal) * 100 : 100 }"></div>
                    <p>{{ customerUsage.CurrentFlow | number: '1.2-2' }} kL</p>
                  </div>
                  <div class="customer-bar-value">
                    <p>Flow</p>
                    <p>{{ [customer] | flowTotal | number: '1.2-2' }} kL</p>
                  </div>
                </div>

                <div class="customer-bar-wrap">         
                  <div class="customer-bar-alert basic-tooltip-alert" *ngIf="customer.weeklyUsage > customer.weeklyAllowance">
                    <i class="fa fa-exclamation"></i>
                    <div class="endpoint-basic-tooltip">
                      <p>Customer's weekly usage has exceed it's weekly usage allowance</p>
                    </div>
                  </div>

                  <div class="customer-bar">
                    <div class="customer-bar-inner" [ngStyle]="{ 'width.%': customer.weeklyAllowance > customer.weeklyUsage ? customer.weeklyUsage / customer.weeklyAllowance * 100 : 100 }"></div>
                    <p>{{ customer.WeeklyUsage | number: '1.2-2' }} kL</p>
                  </div>
                  <div class="customer-bar-value">
                    <p>Usage</p>
                    <p>{{ customer.WeeklyAllowance | number: '1.2-2' }} kL</p>
                  </div>
                </div>
              </div>

            </div>

            <div class="customer-endpoint-table-wrap">
              <table class="customer-endpoint-table">
                <thead class="customer-endpoint-table-header">
                  <th class="endpoint-xlarge-column">Name</th>
                  <th class="endpoint-small-column">Alarms</th>
                  <th>Expected State</th>
                  <th>Next State</th>
                  <th>Ad-Hoc Event</th>
                  <th>Flow Rate / Avg. Rate (kL/hr)</th>
                  <th>Meter Reading (kL)</th>
                  <th>Weekly Usage (kL)</th>
                </thead>
                <tbody class="customer-endpoint-table-body">
                  <tr *ngFor="let endpoint of customer.valveMeters">
                    <!-- Name -->
                    <td class="endpoint-basic-data endpoint-large-column">
                      <div class="primary">
                        {{ endpoint.endpointName }}
                        <div class="endpoint-health">
                          
                          <div class="endpoint-battery">
                            <div class="endpoint-battery-inner" [ngStyle]="{ 'width.%': endpoint.deviceInBatteryVoltage.value > batteryVoltageMax ? '100' : endpoint.deviceInBatteryVoltage.value / batteryVoltageMax * 100, 'background-color': endpoint.deviceInBatteryVoltage.value / batteryVoltageMax * 100 > 20 ? '#159077' : '#E53E3E' }"></div>
                            <div class="endpoint-battery-charging" *ngIf="endpoint.deviceInBatteryVoltage.value > batteryVoltageMax">
                              <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="bolt" class="svg-inline--fa fa-bolt fa-w-10" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
                                <path fill="currentColor" d="M296 160H180.6l42.6-129.8C227.2 15 215.7 0 200 0H56C44 0 33.8 8.9 32.2 20.8l-32 240C-1.7 275.2 9.5 288 24 288h118.7L96.6 482.5c-3.6 15.2 8 29.5 23.3 29.5 8.4 0 16.4-4.4 20.8-12l176-304c9.3-15.9-2.2-36-20.7-36z"></path>
                              </svg>
                            </div>
                          </div>
                          <div class="endpoint-signal">
                            <div class="endpoint-signal-bar"
                              *ngFor="let bar of [0,1,2,3,4]; index as index" [ngStyle]="{ 'height.%': (index + 1) * 20}"
                              [class.enabled]="((endpoint.deviceInSignalStrength.value - signalMin) / (signalMax - signalMin)) * 100 >= index * 20">
                            </div>
                          </div>
        
                        </div>
                      </div>

                      <div class="secondary">
                        {{ endpoint.name }} - {{ endpoint.status | endpointStatus }}
                      </div>

                    </td>
                    
                    <td *ngIf="!endpoint.DisableAlarms" class="endpoint-alarm-data endpoint-small-column">
                      <i class="fa fa-bell" [class.active]="endpoint.aboveExpectedFlowRate.value || endpoint.belowExpectedFlowRate.value"></i>
                      <i class="fa fa-bell" [class.active]="endpoint.unexpectedUsageAlarm.value"></i>
                      <i class="fa fa-bell" [class.active]="endpoint.deviceInEmptyPipeAlarm.value"></i>
                      <i class="fa fa-bell" [class.active]="endpoint.deviceInLeakAlarm.value"></i>
                      <i class="fa fa-bell" [class.active]="endpoint.projectedWeeklyAllocationExceeded.value"></i>
                      <i class="fa fa-bell" [class.active]="endpoint.weeklyAllocationExceeded.value"></i>
                      <i class="fa fa-bell" [class.active]="endpoint.valveStateAlarm.value"></i>
                      <i class="fa fa-bell" [class.active]="endpoint.rainExceeded.value"></i>
                      <i class="fa fa-bell" [class.active]="endpoint.windSpeedExceeded.value"></i>

                      <div class="endpoint-alarm-data-tooltip" *ngIf="endpointHasActiveAlarms(endpoint)">
                        <p *ngIf="endpoint.aboveExpectedFlowRate.value"><i class="fa fa-bell"></i>Flow Rate Above Expected</p>
                        <p *ngIf="endpoint.belowExpectedFlowRate.value"><i class="fa fa-bell"></i>Flow Rate Below Expected</p>
                        <p *ngIf="endpoint.unexpectedUsageAlarm.value"><i class="fa fa-bell"></i>Unexpected Flow Rate</p>
                        <p *ngIf="endpoint.deviceInEmptyPipeAlarm.value"><i class="fa fa-bell"></i>Empty</p>
                        <p *ngIf="endpoint.deviceInLeakAlarm.value"><i class="fa fa-bell"></i>Leak Detected</p>
                        <p *ngIf="endpoint.projectedWeeklyAllocationExceeded.value"><i class="fa fa-bell"></i>Projected Usage Exceeds Allocation</p>
                        <p *ngIf="endpoint.weeklyAllocationExceeded.value"><i class="fa fa-bell"></i>Exceeded Allocation</p>
                        <p *ngIf="endpoint.valveStateAlarm.value"><i class="fa fa-bell"></i>Valve State Alarm</p>
                        <p *ngIf="endpoint.rainExceeded.value"><i class="fa fa-bell"></i>Rain Exceeded</p>
                        <p *ngIf="endpoint.windSpeedExceeded.value"><i class="fa fa-bell"></i>Wind Speed Exceeded</p>        
                      </div>
                    </td>
                    <td *ngIf="endpoint.disableAlarms" class="endpoint-alarm-data-disabled endpoint-small-column"> 
                      <i class="fa fa-bell-slash"></i>
                    </td>
                    <!-- Current State -->
                    <td class="endpoint-basic-data endpoint-regular-column">
                      <div class="primary" title="Device State: {{ endpoint.deviceInValveState.value ? 'Open' : 'Closed' }}&#x0a;Scheduled State: {{ endpoint.scheduledValveState.value ? 'Open' : 'Closed' }}" [class.scheduled]="endpoint.scheduledValveState.value">
                        {{endpoint.expectedValveState.value ? 'Open' : 'Closed'}}

                        <div class="endpoint-basic-data-alert basic-tooltip-alert" *ngIf="endpoint.deviceInValveState.value !== endpoint.expectedValveState.value">
                          <i class="fa fa-exclamation"></i>
                          <div class="endpoint-basic-tooltip">
                            <p>Device State does not match Expected State</p>
                            <p>Device: {{ endpoint.deviceInValveState.value ? 'Open' : 'Closed' }}</p>
                            <p>Expected: {{ endpoint.expectedValveState.value ? 'Open' : 'Closed' }}</p>
                          </div>
                        </div>
                      </div> 
                      <div class="secondary">{{ endpoint.deviceInMeterReading ? (endpoint.deviceInMeterReading.timeStamp | relativeDate) : '-' }}</div>
                    </td>
                    <!-- Next State -->
                    <td class="endpoint-basic-data endpoint-regular-column">
                      <div class="primary">
                        {{ endpoint.endpointDefaultState ? 'Always Open' : (endpoint.nextRequestedValveState.value ? 'Open' : 'Closed') }}
                        <div class="endpoint-basic-data-alert basic-tooltip-alert" *ngIf="endpoint.deviceInNextRequestedValveState.value !== endpoint.nextRequestedValveState.value && endpoint.DeviceInNextRequestedValveState.value !== null && !endpoint.EndpointDefaultState">
                          <i class="fa fa-exclamation"></i>
                          <div class="endpoint-basic-tooltip">
                            <p>Next Device State does not match Next Requested State</p>
                            <p>Device: {{ endpoint.deviceInNextRequestedValveState.value ? 'Open' : 'Closed' }}</p>
                            <p>Expected: {{ endpoint.nextRequestedValveState.value ? 'Open' : 'Closed' }}</p>
                          </div>
                        </div>
                      </div>
                      <div class="secondary">{{ endpoint.deviceInNextRequestedValveStateStr ? (endpoint.deviceInNextRequestedValveState.timeStamp | relativeDate) : '-' }}</div>
                    </td>
                    <!-- Ad-Hoc Control - Next -->
                    <td class="endpoint-basic-data endpoint-large-column">
                      <div class="primary selectable" (click)="editEndpointControl(endpoint)">{{ endpoint.realTimeControlState.value !== undefined ? (endpoint.realTimeControlState.value ? 'Open' : 'Closed') : 'No Event' }} <i class="fa fa-chevron-right"></i></div>
                      <div class="secondary">
                        {{ endpoint.realTimeControlState.value !== undefined ? (endpoint.realTimeControlState.timeStamp | relativeDate) : '-' }}
                        <button *ngIf="endpoint.realTimeControlState.value !== undefined" class="delete-button-small" (click)="wipeEndpointControl(endpoint)">Clear</button>
                      </div>
                    </td>
                    <!-- Flow Rate / Max Rate (kL/hr) -->
                    <td>
                      <div>
                        {{ endpoint.deviceInFlowRate && endpoint.deviceInFlowRate.value ? (endpoint.deviceInFlowRate.value | number: '1.2-2') : '0.00' }} / {{ isValidNumber(endpoint.maximumFlowRate) ? (endpoint.maximumFlowRate | number: '1.2-2') : '0.00'}}
                      </div>
                    </td>
                    <!-- Meter Reading (kL) -->
                    <td>
                      <div>
                        {{ endpoint.deviceInMeterReading ? (endpoint.deviceInMeterReading.value  | number: '1.2-2') : '0.00' }}
                      </div>
                    </td>
                    <!-- Weekly Usage (kL) -->
                    <td>
                      <div>
                        {{ endpoint.calculatedWeeklyUsage ? (endpoint.calculatedWeeklyUsage | number: '1.2-2') : '0.00' }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </ng-template>
        <ng-template #meterUsageLoading>
          <div class="grid-box-loading">
            <div class="loader-spinner"></div>
          </div>
        </ng-template>
      </div>
      <div class="card-arrow">
        <div class="card-arrow-top-left"></div>
        <div class="card-arrow-top-right"></div>
        <div class="card-arrow-bottom-left"></div>
        <div class="card-arrow-bottom-right"></div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-xs-12"></div>
  </div>
</div>

<app-endpoint-control *ngIf="isEndpointControlActive"
  [selectedEndpoint]="selectedEndpoint"
  [inProgress]="isEndpointControlSubmitting"
  (cancelEvent)="closeEndpointControl()"
  (submitEvent)="submitEndpointControl($event)">
</app-endpoint-control>